import { RootState } from '../../store/store'

// Selector to access the complete admin authentication state
export const selectAdminAuthState = (state: RootState) => state.admin

// Selector to access the admin user's profile information
export const selectAdminInfo = (state: RootState) => state.admin.adminInfo

// Selector to check if the admin authentication process is loading
export const selectAdminLoading = (state: RootState) => state.admin.isLoading

// Selector to retrieve any errors from the admin authentication state
export const selectAdminError = (state: RootState) => state.admin.error

// Selector to check if OTP has been sent
export const selectAdminOTPSent = (state: RootState) => state.admin.otpSent

// Selector to get the admin token
export const selectAdminToken = (state: RootState) => state.admin.token
